<template>
  <DefButtonSecondary
    class="def-buy-one-click"
    :disabled="isPair && !isPairSelected"
    @click="handlerClick"
  >
    <span>{{ messages.title }}</span>
  </DefButtonSecondary>
</template>

<script>
import { mapState } from 'vuex';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import DefBuyOneClickForm from '@components/Def/DefBuyOneClick/DefBuyOneClickForm.vue';
import useModal from '@use/useModal/useModal';

export default {
  name: 'DefBuyOneClick',
  components: { DefButtonSecondary },
  props: ['result'],
  data() {
    return {
      modal: useModal(),
    };
  },
  methods: {
    handlerClick() {
      this.modal.show(DefBuyOneClickForm, {}, { width: '340px' });
    },
  },
  computed: {
    ...mapState({
      messages: ({ basket }) => basket.data.messages?.oneClick,
      isPairSelected: ({ product }) => product?.data?.isPairSelected,
      isPair: ({ product }) => product?.data?.product?.isPair,
    }),
  },
};
</script>

<style lang="scss" scoped>
.def-buy-one-click {
  width: 100%;
}
</style>
